import { createSelector } from "reselect";

const usersReportsStateSelector = (state) => state.usersReports;

export const usersSelector = createSelector(
  [usersReportsStateSelector],
  (usersReports) => usersReports.items
);

export const usersCountSelector = createSelector(
  [usersReportsStateSelector],
  (usersReports) => usersReports.count
);

export const usersIsLoadingSelector = createSelector(
  [usersReportsStateSelector],
  (usersReports) => usersReports.isLoading
);
